var map = {
	"./Voldemort's Wand - Img - Final (2)_00.jpg": 2141,
	"./Voldemort's Wand - Img - Final (2)_01.jpg": 2142,
	"./Voldemort's Wand - Img - Final (2)_02.jpg": 2143,
	"./Voldemort's Wand - Img - Final (2)_03.jpg": 2144,
	"./Voldemort's Wand - Img - Final (2)_04.jpg": 2145,
	"./Voldemort's Wand - Img - Final (2)_05.jpg": 2146,
	"./Voldemort's Wand - Img - Final (2)_06.jpg": 2147,
	"./Voldemort's Wand - Img - Final (2)_07.jpg": 2148,
	"./gallery_00.jpg": 2149,
	"./gallery_01.jpg": 2150,
	"./gallery_02.jpg": 2151,
	"./gallery_03.jpg": 2152,
	"./gallery_04.jpg": 2153,
	"./gallery_05.jpg": 2154,
	"./gallery_06.jpg": 2155,
	"./gallery_07.jpg": 2156
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2140;